import { render, staticRenderFns } from "./OsCustomFieldForm.vue?vue&type=template&id=378d74e2&scoped=true"
import script from "./OsCustomFieldForm.vue?vue&type=script&lang=ts"
export * from "./OsCustomFieldForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d74e2",
  null
  
)

export default component.exports